import { render, staticRenderFns } from "./ArrearsExerciseEdit.vue?vue&type=template&id=455d78c4&scoped=true"
import script from "./ArrearsExerciseEdit.vue?vue&type=script&lang=js"
export * from "./ArrearsExerciseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d78c4",
  null
  
)

export default component.exports